import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { Platform } from "react-native";
import { Toast } from "native-base";
import { Activity } from "../../../../../database";
import moment from "moment"

const AutoFeederPondStoreProps = {
  autoFeederPondId: types.maybeNull(types.number),
  autoFeederPond: types.maybeNull(types.frozen()),
  activityId: types.maybeNull(types.number),
  activities: types.optional(types.array(types.frozen()), []),

  queryingActivity: types.maybeNull(types.boolean),
  syncingActivity: types.maybeNull(types.boolean),
  syncedActivity: types.maybeNull(types.boolean),
}

/**
 * Model description here for TypeScript hints.
 */
export const AutoFeederPondStoreModel = types
  .model("AutoFeederPondStore")
  .props(AutoFeederPondStoreProps)
  .views((self) => ({
    get loadingActivity() {
      return self.queryingActivity || self.syncingActivity
    },
    get feedToday() {
      return (self.autoFeederPond?.state?.feeds || []).find((feed: any) => (
        feed.feed_at === moment().format('YYYY-MM-DD')
      ))
    },
    get feedTomorrow() {
      return (self.autoFeederPond?.state?.feeds || []).find((feed: any) => (
        feed.feed_at === moment().add(1, 'day').format('YYYY-MM-DD')
      ))
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof AutoFeederPondStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    async getActivities(sync = true, onFinishSync = undefined) {
      if (!sync) {
        this.set('queryingActivity', true);
        const activities = await Activity.fetch({
          subject_id__in: self.autoFeederPondId,
          subject_type__in: 'App\\AutoFeederPond',
          created_at__gte: moment.utc().subtract(1, 'week').format('YYYY-MM-DD HH:mm:ss'),
          sort: 'created_at,desc'
        }).catch((e) => {
          console.warn(e)
          return []
        })
        this.set('activities', activities.map((activity) => activity.toArray()));
        this.set('queryingActivity', false);
      }
      else {
        this.set('queryingActivity', true);
        this.syncActivities().then(async () => {
          await this.getActivities(false).catch()
          onFinishSync && onFinishSync()
          this.set('syncedActivity', true);
          this.set('queryingActivity', false);
        })
      }
    },
    async syncActivities() {
      if (Platform.OS === 'web') return true;

      this.set('syncingActivity', true)
      const success = await Activity.syncAll(
        {
          subject_id__in: self.autoFeederPondId,
          subject_type__in: 'App\\AutoFeederPond'
        },
        [
          ['activity_logs.subject_id', [self.autoFeederPondId]],
          ['activity_logs.subject_type', ['App\\AutoFeederPond']]
        ], true, undefined, (e) => {
          if (e.message && !Toast.isActive(e.name)) Toast.show({ id: e.name, title: e.message });
        }
      )

      this.set('syncingActivity', false)
      return success
    },
    init() {
      //
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type AutoFeederPondStoreType = Instance<typeof AutoFeederPondStoreModel>
export interface AutoFeederPondStore extends AutoFeederPondStoreType {}
type AutoFeederPondStoreSnapshotType = SnapshotOut<typeof AutoFeederPondStoreModel>
export interface AutoFeederPondStoreSnapshot extends AutoFeederPondStoreSnapshotType {}
export const createAutoFeederPondStoreDefaultModel = () => types.optional(AutoFeederPondStoreModel, {})
